enum AppTypes {
    INIT_APP = 'INIT_APP',
    INIT_APP_LOADING = 'INIT_APP_LOADING',
    INIT_APP_SUCCESS = 'INIT_APP_SUCCESS',
    INIT_APP_FAIL = 'INIT_APP_FAIL',
    SHOW_PLUGIN = 'SHOW_PLUGIN',
    HIDE_PLUGIN = 'HIDE_PLUGIN',
    RESET_PLUGIN = 'RESET_PLUGIN',
    UPDATE_PLUGIN_TITLE_TAG = 'UPDATE_PLUGIN_TITLE_TAG',
    SELECT_INSTANCE = 'SELECT_INSTANCE',
    SET_COMPANY_GROUPS = 'SET_COMPANY_GROUPS',
    CLEAR_INSTANCE = 'CLEAR_INSTANCE',
    TOGGLE_IFRAME = 'TOGGLE_IFRAME',
    PLUGIN_INSTALLED = 'PLUGIN_INSTALLED',
    REPORT_ISSUE = 'REPORT_ISSUE',
    LOADING_FORM = 'LOADING_FORM',
    FORM_LOADED = 'FORM_LOADED',
    FORM_NOT_FOUND = 'FORM_NOT_FOUND',
    FORM_ERROR = 'FORM_ERROR',
    UPDATE_INSTANCE_SETTINGS = 'UPDATE_INSTANCE_SETTINGS',
    UPDATE_KEYWORDS_ERROR = 'UPDATE_KEYWORDS_ERROR',
    UPDATE_KEYWORDS_SUCCESS = 'UPDATE_KEYWORDS_SUCCESS',
    UPDATE_KEYWORDS_LOADING = 'UPDATE_KEYWORDS_LOADING',
    CCP_LOGOUT = 'CCP_AUTH_FAIL'
}

export default AppTypes;
